import React, { useEffect, useState } from "react";
import { addonTypes, SchemaAddon } from "types/carTypes";
import { useDispatch } from "react-redux";
import { createEntry } from "store/authSlice";
import { PostTypes, PSInputBase, PSWysiwyg, PSSubmit } from "components/globals/ui/input/PSInputs";
import PSGallery from "components/globals/PSGallery";
import { Button } from 'components/globals/ui/input/Button';
import { createFormData } from "helpers/utils";
import { ErrorPane } from "components/modals/Panes";

export const AddonForm = ({id, addonType, onSuccess}) => {
	const [postData, updatePostData] = useState(SchemaAddon);
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const dispatch = useDispatch();

	useEffect(() => {
		setNewPostDataProperty("type", addonTypes[0]?.key);
	}, []);

	// coming from input onChange (text and select, type, category)
	const onInputChange = (context, val) => {
		setNewPostDataProperty(context, val);
	};

	const setNewPostDataProperty = (context, val) => {
		updatePostData((prevData) => ({
			...prevData,
			[context]: val,
		}));
	};

	const updateSelectedGalleryFiles = (images) => {
		setNewPostDataProperty("gallery", images);
	};

	const reset = () => {
		updatePostData(SchemaAddon);
	}

	const clearErrorMessage = () => {
		setErrorMessage(null);
	};

	// SUBMIT
	const submitForm = async () => {
		if (!id) {
			setErrorMessage("No ID.");
			return;
		}

		setLoading(true);
		setErrorMessage(null);

		let fd = createFormData(postData, SchemaAddon);

		fd.append("car_id", id);

		try {
			await dispatch(createEntry({ data: fd, entry_type: addonType })).unwrap();
			reset();
			onSuccess();
		} catch (err) {
			setErrorMessage(err.message || "Failed. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<ErrorPane
				visible={errorMessage}
				message={errorMessage}
				onClose={clearErrorMessage}
			/>

			<PSInputBase
				name="title"
				label="Title"
				type="text"
				context="title"
				// value={postData.condition || ""}
				onChange={onInputChange}
			/>

			<PostTypes
				postType={postData?.type}
				data={addonTypes}
				onInputChange={onInputChange}
			/>

			<PSWysiwyg
				name="body"
				label="Body"
				context="body"
				// value={postData.body || ""}
				onChange={onInputChange}
			/>

			<PSGallery
				initialImages={postData.gallery || []}
				onImagesChange={updateSelectedGalleryFiles}
			/>

			<div className="flex items-center justify-between mt-xs">
				
				<Button variant='destructive' onClick={reset}>
					<span>Cancel</span>
				</Button>

				<PSSubmit
					onClick={submitForm}
					loading={loading}
					label={`Save ${addonType === 'cargallery' ? 'Gallery' : 'Mod'}`}
					disabled={loading}
				/>

			</div>
		
		</>
	)
}
